// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3GElX","choiceBoxes":"toolbarselects_choiceBoxes__2fy9r","simpleField":"toolbarselects_simpleField__29Ktv"};